import countryList from "../Mycomponent/dataFiles/country";
import { language } from "../Mycomponent/dataFiles/dataforseo-languages";

export const getCurrentCountryDetails = (location, country_list = []) => {
  const location_list = country_list?.length > 0 ? country_list : countryList;
  // Use find to return the first match
  const data = location_list?.find((item) => item.location_name === location);
  return data ? [data] : []; // Return as an array if found, or an empty array if not
};

export const getCurrentCountryFlagByCode = (location) => {
  const data = countryList?.find((item) => item.location_code === location);
  return data?.location_flag;
};

export const getCurrentCountryFlag = (location) => {
  const data = countryList?.find((item) => item.location_name === location);
  return data?.location_flag;
};

export const getCountryFlag = (location) => {
  if (!location) return "";
  const lastString = location.split(",").pop(); // "India"
  const data2 = countryList?.find((item) => {
    return item.location_name === lastString;
  });
  return data2?.location_flag;
};

const getLanguageCode = (name) => {
  const lang = language?.find((item) => item.language_name === name);
  return lang?.language_code || "en";
};

export const getLanguageName = (code) => {
  const lang = language?.find((item) => item.language_code === code);
  return lang?.language_name || "";
};

export const getDomainNameAndLang = (websiteurl) => {
  const splitArray = websiteurl?.split(",").map((s) => s.trim());
  return {
    domain: splitArray?.[0],
    language: splitArray?.[1],
    code: getLanguageCode(splitArray?.[1]),
  };
};
